import React from 'react';
import { Card } from '../../shared';
import { CardErrorHandlingBody } from './card-error-handling-body';
import { CardErrorHandlingFooter } from './card-error-handling-footer';
import { CardErrorHandlingHeader } from './card-error-handling-header';
export var CardErrorHandling = function (_a) {
    var url = _a.url;
    return (React.createElement(Card, null,
        React.createElement(CardErrorHandlingHeader, null),
        React.createElement(CardErrorHandlingBody, { title: "Something went wrong !", content: "something went wrong and we couldn't complete your request. please refresh the page to try again" }),
        React.createElement(CardErrorHandlingFooter, { url: url })));
};
